import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { AwaitButton } from '../../../../reusable-components/await-button';
import Iconify from '../../../../reusable-components/iconify';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';

EditModal.propTypes = {
  handleClickOpen: PropTypes.func.isRequired,
  editEntity: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  disableSave: PropTypes.bool,
  disableOpenModal: PropTypes.bool,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      element: PropTypes.node.isRequired,
    })
  ),
  edit: PropTypes.bool,
  open: PropTypes.bool,
};

export default function EditModal({
  handleClickOpen,
  editEntity = '',
  handleClose,
  handleSave,
  disableSave,
  disableOpenModal = false,
  fields = [],
  edit,
  open,
}) {
  return (
    <>
      {edit ? (
        <Tooltip title="Edit">
          <IconButton edge="end" color="secondary" onClick={handleClickOpen} sx={{ mr: 0.5 }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          sx={{ mr: 1 }}
          size="small"
          onClick={handleClickOpen}
          startIcon={<Iconify icon="eva:plus-outline" />}
          disabled={disableOpenModal}
        >
          Add {editEntity}
        </Button>
      )}

      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleClose();
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          {edit ? 'Edit' : 'Add'} {editEntity}
          <CloseIconButton onClick={handleClose}/>
        </DialogTitle>
        <DialogContent sx={{ height: '100%', width: '100%' }}>
          <Grid container direction="row" justifyContent="center" alignItems="flex-start" sx={{ p: 1 }}>
            {fields.map((field, idx) => (
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                sx={{ mt: 1.5 }}
                spacing={2}
                key={idx}
              >
                <Box sx={{ width: '100%' }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    {field.label}
                  </Typography>
                  {field.element}
                </Box>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" size="medium" sx={{ width: 150, mr: 2 }} onClick={handleClose}>
            Cancel
          </Button>
          <AwaitButton
            variant="contained"
            color="primary"
            size="medium"
            sx={{ width: 150 }}
            onClick={handleSave}
            disabled={disableSave}
          >
            {edit ? 'Save' : 'Add'}
          </AwaitButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
